<template>
  <v-tabs fixed-tabs>
    <v-tab v-if="showSalesInvoicesTab" key="sales_invoices" ripple
      >Sales Invoices</v-tab
    >
    <v-tab-item key="sales_invoices" class="pa-2" v-if="showSalesInvoicesTab">
      <sales-invoice-list
        :customFilters="filters"
        @generate="generateSalesInvoices"
        :loading="loading"
        :cached-filters="false"
        refName="itiCiFilters"
        refNameColumns="itiCiCols"
      >
        <template v-slot:leftHeader
          ><itinerary-finance-info
            :itinerary="itinerary"
          ></itinerary-finance-info
        ></template>
        <v-btn
          class="ml-2"
          fab
          dark
          color="primary"
          @click="generateSalesInvoices"
          :loading="loading"
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </sales-invoice-list>
    </v-tab-item>
    <v-tab v-if="showReceiptsTab" key="receipts_refunds" ripple
      >Receipts &amp; Refunds</v-tab
    >
    <v-tab-item key="receipts_refunds" class="pa-2" v-if="showReceiptsTab">
      <payment-list
        :customFilters="filters"
        :itinerary="itinerary"
        :cached-filters="false"
        refName="itiPaymentsFilters"
        refNameColumns="itiPaymentsCols"
        ><template v-slot:leftHeader
          ><itinerary-finance-info
            :itinerary="itinerary"
          ></itinerary-finance-info
        ></template>
      </payment-list>
    </v-tab-item>
    <v-tab v-if="showPurchaseInvoicesTab" key="purchase_invoices" ripple
      >Purchase Invoices</v-tab
    >
    <v-tab-item
      key="purchase_invoices"
      class="pa-2"
      v-if="showPurchaseInvoicesTab"
    >
      <purchase-invoice-list
        :customFilters="filters"
        @generate="showSuppliersList = true"
        refName="itiPiFilters"
        refNameColumns="itiPiCols"
        :cached-filters="false"
      >
        <template v-slot:leftHeader
          ><itinerary-finance-info
            v-if="itinerary"
            :itinerary="itinerary"
          ></itinerary-finance-info
        ></template>
        <v-btn
          class="ml-2"
          fab
          dark
          color="primary"
          :loading="loading"
          @click="onShowSuppliersList"
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </purchase-invoice-list>
      <itinerary-details-suppliers-list-dialog
        :show="showSuppliersList"
        :itineraryId="customFilters.itinerary_id"
        @close="showSuppliersList = false"
        @generated="onPurchaseInvoicesGenerated"
        :key="suppListKey"
      ></itinerary-details-suppliers-list-dialog>
    </v-tab-item>
    <v-tab v-if="showPiPaymentsTab" key="pi_payments" ripple>PI Payments</v-tab>
    <v-tab-item
      key="pi_payments"
      class="pa-2"
      v-if="itinerary && showPiPaymentsTab"
    >
      <purchase-invoice-payment-list
        :customFilters="{ iti_reference_contains: itinerary.reference }"
        :itinerary="itinerary"
        refName="itiPiPaymentsFilters"
        refNameColumns="itiPiPaymentsCols"
        ><template v-slot:leftHeader
          ><itinerary-finance-info
            :itinerary="itinerary"
          ></itinerary-finance-info
        ></template>
      </purchase-invoice-payment-list>
    </v-tab-item>
    <v-tab key="commission" ripple>Agent Commission</v-tab>
    <v-tab-item key="commission" class="pa-2">
      <itinerary-commission v-model="itinerary"></itinerary-commission>
    </v-tab-item>
    <v-tab
      key="supplierCommission"
      ripple
      v-if="$store.getters.hasAccessTo('administration_panel:business_models')"
      >Supplier Commission</v-tab
    >
    <v-tab-item
      key="supplierCommission"
      class="pa-2"
      v-if="$store.getters.hasAccessTo('administration_panel:business_models')"
    >
      <itinerary-supplier-commission
        v-model="itinerary"
      ></itinerary-supplier-commission>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import {
  GENERATE_SALES_INVOICES,
  TASK_STATUS_QUERY,
} from "../../../constants/graphql";
import EventBus from "../../../store/event-bus";
import SalesInvoiceList from "../finances/sales-invoices/SalesInvoiceList";
import PaymentList from "../finances/payments/PaymentList";
import PurchaseInvoiceList from "../finances/purchase-invoices/PurchaseInvoiceList";
import PurchaseInvoicePaymentList from "../finances/purchase-invoice-payments/PurchaseInvoicePaymentList";
import ItineraryDetailsSuppliersListDialog from "./ItineraryDetailsSuppliersListDialog";
import ItineraryCommission from "./ItineraryCommission";
import ItineraryFinanceInfo from "./ItineraryDetailsFinanceInfo";
import ItinerarySupplierCommission from "./ItinerarySupplierCommission";
const randomize = require("randomatic");
export default {
  components: {
    ItineraryDetailsSuppliersListDialog,
    SalesInvoiceList,
    PaymentList,
    PurchaseInvoiceList,
    PurchaseInvoicePaymentList,
    ItineraryCommission,
    ItineraryFinanceInfo,
    ItinerarySupplierCommission,
  },

  name: "ItineraryDetailsFinancesTabs",

  props: {
    customFilters: {
      type: Object,
      default: () => null,
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      result: {
        type: Object,
      },
      taskId: "",
      loading: false,
      skipCheckStatus: true,
      suppliersDialog: false,
      filters: this.customFilters ? { ...this.customFilters } : null,
      showSuppliersList: false,
      suppListKey: randomize("Aa0", 32),
    };
  },
  computed: {
    //https://tracker.globetrack.ie/issues/7523
    showSalesInvoicesTab() {
      return this.$store.getters.hasAccessTo("finances:sales_invoices");
    },
    showReceiptsTab() {
      return this.$store.getters.hasAccessTo("finances:receipts");
    },
    showPurchaseInvoicesTab() {
      return this.$store.getters.hasAccessTo("finances:purchase_invoices");
    },
    showPiPaymentsTab() {
      return this.$store.getters.hasAccessTo("finances:pi_payments");
    },
    //endof https://tracker.globetrack.ie/issues/7523
  },
  methods: {
    generateSalesInvoices() {
      this.$apollo
        .mutate({
          mutation: GENERATE_SALES_INVOICES,
          variables: {
            itineraryId: this.customFilters.itinerary_id,
          },
        })
        .then(
          this.generateSalesInvoicesHandler,
          this.generateSalesInvoicesErrorHandler
        );
    },
    generateSalesInvoicesErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", { msg: err, color: "danger" });
    },
    generateSalesInvoicesHandler(result) {
      this.taskId = result.data.generateSalesInvoice.id;
      this.loading = true;
      this.skipCheckStatus = false;
    },
    onPurchaseInvoicesGenerated() {
      this.showSuppliersList = false;
      this.filters = { ...this.customFilters };
      EventBus.$emit("reloadPurchaseInvoiceList");
    },
    onShowSuppliersList() {
      this.suppListKey = randomize("Aa0", 32);
      this.showSuppliersList = true;
    },
  },

  apollo: {
    taskStatus: {
      query: TASK_STATUS_QUERY,
      variables: function () {
        return { taskId: this.taskId };
      },
      result({ data, loader, networkStatus }) {
        this.skipCheckStatus = true;
        if (data.taskStatus.status == "IN_PROGRESS") {
          setTimeout(() => {
            this.skipCheckStatus = false;
          }, 2000);
        } else {
          this.loading = false;
          //update filters to reload lists
          this.$store.dispatch("showAppSnackbar", {
            msg: "Generation Complete",
            color: "success",
          });
          this.filters = { ...this.customFilters };
          EventBus.$emit("reloadSalesInvoiceList");
        }
      },
      skip() {
        return this.skipCheckStatus;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsFinancesTabs.vue